/* Sends the Shopify bag to the Seloire checkout. Prices are checked again there. */
(function () {
  var CHECKOUT = "https://checkout.seloirelondon.com/";

  function encode(value) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(value))))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/g, "");
  }

  function cookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) return "";
    return decodeURIComponent(parts.pop().split(";").shift() || "");
  }

  function clickId(name, cookieName) {
    var fromUrl = new URLSearchParams(location.search).get(name) || "";
    if (fromUrl) return fromUrl;
    var bits = cookie(cookieName).split(".");
    if (bits[0] !== "GCL" || bits.length < 3) return "";
    return bits.slice(2).join(".");
  }

  document.addEventListener("click", function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('button[name="checkout"], .cart__checkout')
      : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          if (button.form) button.form.submit();
          return;
        }
        var bag = {
          items: cart.items.map(function (item) {
            return {
              id: item.variant_id,
              h: item.handle,
              t: item.product_title,
              v: item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "",
              q: item.quantity,
              p: item.price,
              c: item.compare_at_price || null,
              i: item.image || "",
              pid: item.product_id || null
            };
          }),
          cur: cart.currency,
          country: (window.Shopify && window.Shopify.country) || "GB",
          ads: {
            gclid: clickId("gclid", "_gcl_aw"),
            gbraid: clickId("gbraid", "_gcl_gb"),
            wbraid: new URLSearchParams(location.search).get("wbraid") || ""
          }
        };
        location.href = CHECKOUT + "#c=" + encode(bag);
      })
      .catch(function () {
        if (button.form) button.form.submit();
      });
  }, true);
})();
